import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import ContainerBase from '@mui/material/Container'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Image = styled(ImageBase)`
    border-radius: 20px;
    overflow: hidden;
`

export const Link = styled(LinkBase)`
    display: block;
    margin-top: 40px;
    clear: both;
`

export const List = styled.ul`
    flex-wrap: wrap;
    margin-top: 10px;
    list-style-type: none;

    &:after {
        display: block;
        content: '';
        clear: both;
    }
`

export const Item = styled.li`
    margin-top: 20px;
    display: flex;

    .icon {
        margin-top: 9px;
        flex-shrink: 0;
    }
`

export const ItemText = styled.div`
    margin-left: 15px;
    ${(props) => props.theme.typo.bodyL};
`

export const Title = styled.p`
    ${(props) => props.theme.typo.displayXS};
    ${(props) => props.theme.fontWeight.medium};
    ${(props) => props.theme.gradient.nector};
    background-clip: text;
    color: transparent;
    text-transform: uppercase;

    @media ${(props) => props.theme.query.mobile} {
        margin-top: 30px;
        text-align: center;
    }
`

export const Subtitle = styled.h2`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.bold};
    margin-top: 10px;

    @media ${(props) => props.theme.query.mobile} {
        ${(props) => props.theme.typo.displayM};
        text-align: center;
    }
`

export const Description = styled.p`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    margin-top: 20px;
    display: block;
`
export const Container = styled(ContainerBase)``

export const Wrapper = styled.div<{ $mode: ThemeModeType; $fullWidth: boolean }>`
    color: ${(props) => props.theme.color.white};

    ${Title} + ${Subtitle} {
        ${(props) => props.theme.typo.displayL};
        ${(props) => props.theme.fontWeight.regular};

        @media ${(props) => props.theme.query.mobile} {
            margin-top: 0px;
        }
    }

    ${(props) =>
        props.$fullWidth &&
        `
            background: ${props.theme.color[props.$mode === 'Light' ? 'g100' : 'p600']};
            padding: 105px 20px;
        `}

    ${(props) =>
        props.$mode === 'Light'
            ? `
        ${Subtitle} {
            color: ${props.theme.color.p500};
        }
        ${Description}, ${List} {
            color: ${props.theme.color.g600};
        }
    `
            : ``};

    ${(props) =>
        !props.$fullWidth &&
        `${Container}{
            background: ${props.theme.color[props.$mode === 'Light' ? 'g100' : 'p600']};
            padding: 100px 20px;
            border-radius: 20px;
            margin-top:15px;
            margin-bottom:15px;
            
             @media ${props.theme.query.min.tablet} {
                padding-left:0;
                padding-right:0;
                margin-top:50px;
                margin-bottom:50px;
            }
        }`}
`

export const Button = styled(ButtonBase)`
    span:first-child {
        display: flex;
        align-items: center;
        line-height: initial;
        white-space: normal;

        svg {
            margin-left: 8px;
            flex-shrink: 0;
        }
    }
`
